import {
  UNLOCK_LINKEDIN_BANNER_REQUEST,
  UNLOCK_LINKEDIN_BANNER_SUCCESS,
  UNLOCK_LINKEDIN_BANNER_FAILURE,
  RESET_UNLOCK_LINKEDIN_BANNER,
} from "../actionTypes";

// Action creators
export const unlockLinkedInBannerRequest = (data) => ({
  type: UNLOCK_LINKEDIN_BANNER_REQUEST,
  payload: data,
});

export const unlockLinkedInBannerSuccess = (message) => ({
  type: UNLOCK_LINKEDIN_BANNER_SUCCESS,
  payload: message,
});

export const unlockLinkedInBannerFailure = (error) => ({
  type: UNLOCK_LINKEDIN_BANNER_FAILURE,
  payload: error,
});

export const resetUnlockLinkedInBannerMessage = () => ({
  type: RESET_UNLOCK_LINKEDIN_BANNER,
});
